export default __webpack_public_path__ + "screens.46931d60.png";